import { ProductCatalog } from "../../types/productCatalog";
import { Box, Card, CardContent, CardMedia, Link, Typography } from "@mui/material";
import React from "react";
import { Link as RouterLink } from "react-router-dom";

export function ProductCard({ product }: { product: ProductCatalog }) {
  return (
    <Card variant="outlined" sx={{ my: 2 }}>
      <Box sx={{ display: "flex", flexDirection: "row" }}>
        <CardMedia sx={{ width: 200 }} image={product.primaryPhotoUrl} />
        <CardContent sx={{ flexGrow: 1 }}>
          <Typography gutterBottom variant="subtitle1" component="div">
            <Link component={RouterLink} to={`/product-catalog/${product.id}`}>
              {product.title || "Untitled"}
            </Link>
            <Typography variant="caption"></Typography>
          </Typography>
          <Typography variant="body2" color="text.secondary">
            MPN: {product.merchantProductNumber} | Stock: {product.quantity || 0}
          </Typography>
        </CardContent>
      </Box>
    </Card>
  );
}
